function DefaultPlanResourcesService($resource, $window) {
    return $resource(
        `${styleEnv}customizations/Default/planResources/:gaId.json`,
        {
            gaId: "@gaId"
        },
        {
            query: {
                method: "GET",
                isArray: false,
                cache: true
            }
        }
    );
}

DefaultPlanResourcesService.$inject = ["$resource", "$window"];

export default DefaultPlanResourcesService;
